import axios from "axios";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { useQuery } from "react-query";


export const QUERY_KEY_FOR_CHAT_HISTORY = "chat-history";

export type ChatHistoryPage = {
    items: any[];
    total: number;
    currentPage: number;
    lastPage: number;
    perPage: number;
};

const getData = async (props: {
    token: string;
    page: number;
    perPage: number;
}): Promise<ChatHistoryPage> => {
    const url = `${END_POINT.BASE_URL}/v1/chat-history`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${props.token}`,
        },
        params: {
            page: props.page,
            per_page: props.perPage,
        },
    };
    const res = await axios.get(url, config);
    const d = res.data;

    return {
        items: Array.isArray(d.data) ? d.data : [],
        total: d.total ?? 0,
        currentPage: d.current_page ?? 1,
        lastPage: d.last_page ?? 1,
        perPage: d.per_page ?? props.perPage,
    };
};
const getSmartData = async (props: { token: string }) => {
    const url = `${END_POINT.BASE_URL}/v1/smart-chat-history`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${props.token}`,
        },
    };
    const res = await axios.get(url, config);

    const data = res.data.map((item: any) => ({
        ...item,
    }));

    return data;
};

type UseGetChatHistoryOptions = {
    page?: number;
    perPage?: number;
};

export const useGetChatHistory = (options: UseGetChatHistoryOptions = {}) => {
    const { page = 1, perPage = 15 } = options;
    const { token } = useGetUserInfo();
    const queryData = useQuery(
        [QUERY_KEY_FOR_CHAT_HISTORY, page, perPage],
        () => getData({ token, page, perPage }),
        {
            onError: (err: any) => { },
            onSuccess: (data) => { },
        }
    );

    return queryData;
};
export const useSmartGetChatHistory = () => {
    const { token } = useGetUserInfo();
    const queryData = useQuery(
        [QUERY_KEY_FOR_CHAT_HISTORY],
        () => getSmartData({ token }),
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onError: (err: any) => { },
            onSuccess: (data) => { },
        }
    );

    return queryData;
};
